import {NUMWASS} from "../Constantes";

export const iniciarChatWass = ({mensaje='Hola Magaza'}) =>{
    let texto = encodeURI(mensaje)
    let link = `https://api.whatsapp.com/send?phone=${NUMWASS}&text=${texto}`
    window.open(link)
}